import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { GoogleLogin, type CredentialResponse } from '@react-oauth/google'
import { useAuthStore } from '@/stores/authStore'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Loading } from '@/components/shared/Loading'

export function LoginPage() {
  const { user, loading, error, loginWithGoogle } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (user) {
      navigate('/dashboard')
    }
  }, [user, navigate])

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      try {
        await loginWithGoogle(credentialResponse.credential)
        navigate('/dashboard')
      } catch {
        // 에러는 store에서 처리됨
      }
    }
  }

  const handleGoogleError = () => {
    console.error('Google 로그인 실패')
  }

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <Loading size="lg" text="인증 중..." />
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <Card className="w-[400px]">
        <CardHeader className="text-center">
          <div className="mb-2 text-4xl">🌱</div>
          <CardTitle>그린메이트 리텐션 관리자</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-sm text-muted-foreground">
            Google 계정으로 로그인하세요
          </p>
          <div className="flex justify-center">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
              locale="ko"
            />
          </div>
          {error && <p className="text-center text-sm text-red-500">{error}</p>}
          <p className="text-center text-xs text-gray-500">내부 사용자 전용</p>
        </CardContent>
      </Card>
    </div>
  )
}
